import { render, staticRenderFns } from "./WV-SL-Disclosure.vue?vue&type=template&id=8f00af3c&scoped=true&"
import script from "./WV-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./WV-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./WV-SL-Disclosure.vue?vue&type=style&index=0&id=8f00af3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f00af3c",
  null
  
)

export default component.exports